import React,{useState,useEffect} from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import AccountFooter from '../AccFooter';
import Header from '../Header';
import { Container } from '@mui/material';
import AgentSideBar from '../../agent/components/AgentSideBar';
import UserSideBar from '../../user/components/UsersSideBar';
import useIsMobile from '../../hooks/useIsMobile';
import use2FAStatus from '../../hooks/use2FAStatus';
import Popup from '../Popup';
import { useSelector } from 'react-redux';


const Layout = ({ type, agent, user }) => {
  const location = useLocation();
  const isAgentChatPage = location.pathname === '/agent/chat';
  const isMobile = useIsMobile();
  const [showModal, setShowModal] = useState(false);
  const { isSecurityRequired, loading } = use2FAStatus();
  const reduxLoading = useSelector(state => state.user.loading);

  console.log(isSecurityRequired)

  useEffect(() => {
    const path = location.pathname;
    if (
      (path.startsWith('/user') || path.startsWith('/agent')) &&
      !loading &&
      !reduxLoading &&
      isSecurityRequired
    ) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [location.pathname, isSecurityRequired, loading, reduxLoading]);
  
    const popup = (
      <Popup open={showModal} togglePopUp={() => {}}>
        <h2>Set up Two-Factor Authentication</h2>
        <p>
          For your security, please set up 2FA with Google Authenticator.
        </p>
        <a href="/auth/2fa-setup">Go to 2FA Setup</a>
      </Popup>
    );

  if (type === 'auth') {
    return (
      <>
        {popup}
        <Header auth={true} />

        <div className='auth-content'>
          <Outlet />
        </div>
      </>
    );
  }

  if (type === 'acc' || type === undefined) {
    return (
      <div className={`p-account`}>
        <>
        {popup}
          <Header account={true} />

          {!isMobile && (agent ? <AgentSideBar /> : <UserSideBar />)}

          <div className='c-acc-content'>
            <Container disableGutters className='c-acc-container'>
              <Outlet />
            </Container>
            <AccountFooter />
          </div>
        </>
      </div>
    );
  }

  if (type === 'pool') {
    return (
      <div className={`p-account without`}>
        <>
        {popup}
          <Header account={false} chat={true} />
          <div className='c-acc-content without'>
            <Container disableGutters className='c-acc-container'>
              <Outlet />
            </Container>
          </div>
        </>
      </div>
    );
  }

  if (type === 'chat') {
    return (
      <div className={`p-account ${isAgentChatPage ? 'p-account-chat' : ''}`}>
        <>
        {popup}
          <Header account={false} chat={true} />

          <Outlet />
        </>
      </div>
    );
  }

  if (type === 'tx') {
    return (
      <div className='p-account without'>
              {popup}
        <Header payment={true} />

        <div className='c-acc-content without'>
          <Container disableGutters className='c-760'>
            <Outlet />
          </Container>
        </div>
      </div>
    );
  }

  if (type === 'tx-single') {
    return (
      <div className='p-account without'>
              {popup}
        <Header account={true} />

        <div className='c-acc-content without '>
          <Container disableGutters className='c-tx-single'>
            <Outlet />
          </Container>
        </div>
      </div>
    );
  }
};

Layout.propTypes = {
  children: PropTypes.object,
  type: PropTypes.string.isRequired,
  agent: PropTypes.bool.isRequired,
  user: PropTypes.bool.isRequired,
};

export default Layout;
